import React, { useState } from "react";
import { downloadPdf } from "../helper/PdfHelper";

export function FileDownloader() {
  const [uuidValue, setUuidValue] = useState("");
  const [error, setError] = useState("");

  return (
    <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" id="form2">
      <label for="uuidValue" class="form-label inline-block mb-2 text-gray-700">
        Download a file using the Validation Code
      </label>
      <input
        class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        id="uuidValue"
        type="text"
        placeholder="aR1CcNbvxKzem1xp9VQCV6"
        onChange={(e) => {
          setUuidValue(e.target.value);
        }}
      />
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="button"
        form="form2"
        onClick={async (e) => {
          setError("");
          if (uuidValue) {
            downloadPdf({ uuidValue, setError });
          }
        }}
      >
        Submit
      </button>
      {error && <p className="mt-4 text-red-600	">{error}</p>}
    </form>
  );
}
